import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';

import { GetStartedComponent } from './get-started/get-started.component';
import { VideoTutorialsComponent } from './video-tutorials/video-tutorials.component';
import { FaqComponent } from './faq/faq.component';
import { DefinitionsComponent } from './definitions/definitions.component';
import { MethodologyComponent } from './methodology/methodology.component';
import { BrowserSupportComponent } from './browser-support/browser-support.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FeedbackFormComponent } from './contact-us/feedback-form/feedback-form.component';
import { OurOfficesComponent } from './contact-us/our-offices/our-offices.component';
import { TechnicalSupportComponent } from './contact-us/technical-support/technical-support.component';
import { HelpResourcesLayoutComponent } from './help-resources-layout/help-resources-layout.component';
import { DefinitionsContentComponent } from './definitions/definitions-content/definitions-content.component';
import { SharedUiModule } from '@emi/shared/ui';
import { VideoPlayerComponent } from './video-tutorials/video-player/video-player.component';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatButtonModule,
      MatFormFieldModule,
      MatSelectModule,
      MatExpansionModule,
      SharedUiModule
    ],
    declarations: [
      GetStartedComponent,
      VideoTutorialsComponent,
      VideoPlayerComponent,
      FaqComponent,
      DefinitionsComponent,
      DefinitionsContentComponent,
      MethodologyComponent,
      BrowserSupportComponent,
      ContactUsComponent,
      FeedbackFormComponent,
      OurOfficesComponent,
      TechnicalSupportComponent,
      HelpResourcesLayoutComponent
    ],
    exports: [
      GetStartedComponent,
      VideoTutorialsComponent,
      VideoPlayerComponent,
      FaqComponent,
      DefinitionsComponent,
      DefinitionsContentComponent,
      MethodologyComponent,
      BrowserSupportComponent,
      ContactUsComponent,
      FeedbackFormComponent,
      OurOfficesComponent,
      TechnicalSupportComponent,
      HelpResourcesLayoutComponent
    ],
})
export class HelpResourcesModule {}
